import { FormatStructureEditor } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { AbstractFormatValidator } from "./AbstractFormatValidator";

export abstract class AbstractObjectsValidator extends AbstractFormatValidator {
  constructor() {
    super();
  }

  public validate(format: FormatStructureEditor): IFormatAlert[] {
    return this.concat(...this.extractObjects(format).map(o => this.validateObject(o)));
  }

  protected abstract validateObject(object: IFormatObjectEditable): IFormatAlert[];
}
